import request from '@/plugins/axios';

// POST
// /_product_/file/upload
// 上传文件
export function fileUpload(data) {
    return request[0]({
        url: '/_product_/file/upload',
        method: 'post',
        data
    })
}

//POST
// /_product_/file/getSts
// 获取STS
export function getFileSts() {
    return request[0]({
        url: '/_product_/file/getSts',
        method: 'post',
    })
}